import { Injectable, inject } from "@angular/core";
import { NotificationService } from "./notification.service";
import { AddressLike, Block, JsonRpcProvider, Transaction, TransactionReceipt, TransactionResponse, Wallet, WebSocketProvider, id, Interface, Log, Contract, JsonRpcApiProvider, BrowserProvider, ProviderEvent, Eip1193Provider, JsonRpcSigner } from 'ethers';
import { BaseService } from "./base-service";
import { environment } from "../../environments/environment";

import { BehaviorSubject, Observable } from "rxjs";



/**
 * Servicio para realizar transacciones a traves de MetaMask
 * https://medium.com/@javed.baloch/metamask-integration-with-next-js-and-web3-js-d05287ec9b23
 */
declare global {
    interface Window {
        ethereum: any
    }
}
@Injectable({
    providedIn: 'root'
  })
export class MetaMaskService extends BaseService {   
    metamaskProvider?: BrowserProvider;
    //serviceExploradorBloques = inject(ExploradorDeBloquesService);
    procesandoRequestAccounts = false;
    _bloqueado = false;
    _currentAccount:BehaviorSubject<string> = new BehaviorSubject<string>("Sin cuenta conectada");

    get currentAccount(): Observable<string>{
        return this._currentAccount;
    }
    get habilitado(): boolean {
        let retorno = false;
        if (this.metamaskProvider){
            retorno = true;
        }
        //retorno = false;
        return retorno;

    }

    get bloqueado():boolean {
        return this._bloqueado
    }
    
    constructor(){
        super();
        this._currentAccount.next("");
        console.log("** Registrandose a eventos de metamask")
        if (window.ethereum != undefined){
            window.ethereum.on("connect", (chainId: any) => {
                console.log(`****** connect:${JSON.stringify(chainId)}`)
            });
            window.ethereum.on("disconnect ", (chainId: any) => {
                console.log(`****** disconnect :${chainId}`)
            });
            window.ethereum.on("chainChanged", (chainId: any) => {
                console.log(`****** chainChanged:${chainId}`)
            });
            window.ethereum.on("accountsChanged", async (accounts: string[]) => {
                console.log(`****** accountsChanged:`)
                
                if (accounts.length > 0){
                    this._bloqueado = false;
                    console.log(`Cuenta actual:${accounts[0]}`);
                    this._currentAccount.next(accounts[0]);
                } else {
                    console.log("Metamask bloqueado");
                    this._bloqueado = true;;
                }
                accounts.forEach(cuenta => console.log(`${cuenta}`))
               

            });
            window.ethereum.on("message ", (chainId: any) => {
                console.log(`****** message :${chainId}`)
            });
            console.log("window.ethereum existe");
            const kk = new BrowserProvider(window.ethereum);
            this.metamaskProvider = new BrowserProvider(window.ethereum);
           
            this.metamaskProvider?.on("network", args => {
                console.log(`*** network ${args}`);
            }).catch(
                reason => console.error(`*** network Error consultando debug ${reason}`)
            ).finally(
                ()=> console.log("*** network Fin de llamada de debug")
            )
            this.eth_requestAccounts();
        } else {
            console.warn("window.ethereum no existe");
            this._currentAccount.next("Wallet no disponible");
        }
        
    }


    /*
    getConnectedAccount():string|undefined{
        return this.currentAccount;
    }
    */
    getProvider():BrowserProvider | undefined{
        return this.metamaskProvider;
    }
    listAccounts() {
        this.metamaskProvider?.listAccounts().then(
            signers => {
                signers.forEach(signer => console.log(signer.address));
            }
        ).catch(
            reason => console.error(`Error consultando cuentas ${reason}`)
        ).finally(
            ()=> console.log("Fin de llamada de cuentas")
        )
    }
    conectar() {
        console.log("Conectando con metamask");
        this.metamaskProvider?.getSigner().then(
            signer => {
                console.log(`signer:${this.getJSON(signer)}`);
            }
        ).catch(
            reason => console.error(`Error consultando signer ${reason}`)
        ).finally(
            ()=> console.log("Fin de llamada de signer")
        )
        
        
        this.metamaskProvider?.listAccounts().then(
            signers => {
                signers.forEach(signer => console.log(signer.address));
            }
        ).catch(
            reason => console.error(`Error consultando cuentas ${reason}`)
        ).finally(
            ()=> console.log("Fin de llamada de cuentas")
        )
        
        this.metamaskProvider?.getBlockNumber().then(
            value => {
                console.log(`Bloque: ${value}`);
            }
        ).catch(
            reason => console.error(`Error consultando bloque ${reason}`)
        ).finally(
            ()=> console.log("Fin de llamada getBlockNumber")
        )
        this.metamaskProvider?.getNetwork().then(
            value => {
                console.log(`Network: ${this.getJSON(value)}`);
            }
        ).catch(
            reason => console.error(`Error consultando Network ${reason}`)
        ).finally(
            ()=> console.log("Fin de llamada Network")
        )
    }
    eth_requestAccounts() {
        console.log(`*** START eth_requestAccounts.${this._bloqueado}`);
        //console.log(`${window.ethereum._metamask.isUnlocked()}`)
        //let acc = await this.metamaskProvider?.send("eth_requestAccounts", []);
        //if (!this.bloqueado){
            this.procesandoRequestAccounts = true;
            console.log("Pidiendo a metamask cuenta activa");
            this.metamaskProvider?.send("eth_requestAccounts", []).then(
                acc=> {
                    console.log("eth_requestAccounts response");
                    acc.forEach((value:any) => console.log(`* ${value}`));
                    if (acc.length > 0){
                        console.log(`Se establece como cuenta activa ${acc[0]}`);
                        this._currentAccount.next(acc[0]);
                    }
                    this.procesandoRequestAccounts = false;
                }
            
            ).catch(
                error => {
                    console.warn(`Error pidiendo cuenta activa a metamask ${JSON.stringify(error)}`)
                }
            ).finally (
                ()=> {
                    //this.procesandoRequestAccounts = false;
                    console.log("*** END eth_requestAccounts");
                }
            );
        //} else {
        //    this.notificationService.showSnackBarTimeout("Wallet bloqueado. Por favor desbloquealo", 3000);
       // }
       
    }
    getSigner():Promise<JsonRpcSigner>|undefined{
        return this.metamaskProvider?.getSigner();
    }
    
    /*
    dameMiEOAInfo() {
        this.metamaskProvider?.send
        this.metamaskProvider?.getSigner().then(
            jsonRPCSigner => {
                jsonRPCSigner.sendTransaction({
                    to: environment.scGestionValidadoresAddress
            });
            }
        )     
    }
    */
}